import { SVGProps } from 'react';

const SvgEditSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M11.923 3.296a.833.833 0 0 0-1.179 0L10.04 4 12 5.96l.704-.704a.833.833 0 0 0 0-1.179l-.781-.78Zm1.488 2.667a1.833 1.833 0 0 0 0-2.593l-.781-.78a1.833 1.833 0 0 0-2.593 0l-7.87 7.87v3.373H5.54l7.87-7.87Zm-2.118.704-1.96-1.96-6.166 6.167v1.96h1.96l6.166-6.167Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgEditSmall;
